import { useEffect, useState } from "react";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { useDispatch, useSelector } from "react-redux";
import {
  getTrainingDefinitionAssignmentAction,
  deleteTrainingDefinitionAssignmentAction,
  createTrainingDefinitionAssignmentAction,
} from "../../actions";
import {
  getIsLoading,
  getCollaboratorsList,
  getCanAssign,
  getAssignedCollaborators,
} from "../../selectors";
import { RESET_TRAINING_ASSIGNMENT } from "../../actionTypes";
import { openDialogAction } from "@icarius-common/dialog/actions";
import { getLocalizedString } from "@icarius-localization/strings";

const useTrainingAssignment = (trainingCode) => {

  const [createDialogIsOpen, setCreateDialogIsOpen] = useState(false);

  const dispatch = useDispatch();
  const isLoading = useSelector(getIsLoading);
  const assignedCollaborators = useSelector(getAssignedCollaborators);
  const collaboratorsList = useSelector(getCollaboratorsList);
  const canAssign = useSelector(getCanAssign);

  useEffect(() => {
    if (Boolean(trainingCode)) {
      dispatch(getTrainingDefinitionAssignmentAction(trainingCode));
    }
    return () => dispatch({ type: RESET_TRAINING_ASSIGNMENT });
  }, [dispatch, trainingCode])

  const handleOpenDeleteDialog = (gridRef) => {
    let selectedRows = gridRef.api.getSelectedRows();
    if (selectedRows.length === 0) {
      dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectAtLeastOneRecord"), severity: "warning" }));
      return;
    }
    
    const collaborators = selectedRows.map((item) => item['CODIGO DE EMPLEADO']);
    
    dispatch(openDialogAction({
      maxWidth: "sm",
      title: getLocalizedString("atention"),
      msg: getLocalizedString("trainingAssignmentDeleteQuestion"),
      onConfirm: () => dispatch(deleteTrainingDefinitionAssignmentAction(trainingCode, { collaborators })),
    }));
  }
  
  const handleOpenCreateDialog = () => {
    setCreateDialogIsOpen(true);
  }

  const handleCloseCreateDialog = () => {
    setCreateDialogIsOpen(false);
  }

  const handleAssign = (collaborators) => {
    dispatch(createTrainingDefinitionAssignmentAction(trainingCode, { collaborators }))
      .then((resp) => {
        if (resp.status === 200) {
          handleCloseCreateDialog();
        }
      })
  }

  const state = {
    createDialogIsOpen,
  }

  const handlers = {
    handleOpenDeleteDialog,
    handleOpenCreateDialog,
    handleCloseCreateDialog,
    handleAssign,
  }

  return {
    isLoading,
    canAssign,
    assignedCollaborators,
    collaboratorsList,
    state,
    handlers,
  }
}

export default useTrainingAssignment;